module.exports = __webpack_public_path__ + "img/3_1.a7eb4472.svg";